/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type OnboardingOrgInvite_viewer = {
    readonly user: {
        readonly " $fragmentRefs": FragmentRefs<"CopyPersonalInviteLinkBtn_user">;
    } | null;
    readonly " $refType": "OnboardingOrgInvite_viewer";
};
export type OnboardingOrgInvite_viewer$data = OnboardingOrgInvite_viewer;
export type OnboardingOrgInvite_viewer$key = {
    readonly " $data"?: OnboardingOrgInvite_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"OnboardingOrgInvite_viewer">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "excludeCalendars"
        },
        {
            "defaultValue": "",
            "kind": "LocalArgument",
            "name": "orgRelayId"
        },
        {
            "defaultValue": "",
            "kind": "LocalArgument",
            "name": "queryInput"
        }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "OnboardingOrgInvite_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "CopyPersonalInviteLinkBtn_user"
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Viewer",
    "abstractKey": null
} as any;
(node as any).hash = '2c7897955461970405bee516942d6fa0';
export default node;
